import * as amplitude from "@amplitude/analytics-react-native"
import { useNavigation, useRoute } from "@react-navigation/native"
import { LinearGradient } from "expo-linear-gradient"
import React, { useContext, useEffect, useRef, useState } from "react"
import { View } from "react-native-animatable"
import { ScrollView } from "react-native-gesture-handler"
import { Bubble, GiftedChat } from "react-native-gifted-chat"
import { IconButton } from "react-native-paper"
import { connect } from "react-redux"
import FilledButtonM from "../../../common/components/button/FilledButtonM"
import { SpeechBubbleM } from "../../../common/components/speech-bubble/SpeechBubbleM"
import TextM from "../../../common/components/text/TextM"
import { theme } from "../../../common/theme/theme"
import { DimensionsContext } from "../../../common/utils/mobileUtils"
import { apiIdle, apiRequest } from "../../../data/redux/actions/api"
import { ChampionImageM } from "../../../student/champions/ChampionImageM"
import {
    getDiagnosticData,
    getMotivationSeeMoreData,
    getPageComment,
} from "../DiagnosticHelpers"

function MotivationSeeMoreScreen(props) {
    const dimensions = useContext(DimensionsContext)
    const navigation = useNavigation()
    const route = useRoute()
    const page = Number(route?.params?.pageNumber) || 1
    const scrollViewRef = useRef(null)

    const diagnosisData = getDiagnosticData(props.analysisData)

    const pageData = diagnosisData[page - 1]

    const { formattedData, studentName } = getMotivationSeeMoreData(
        props.analysisData
    )

    const [messages] = useState(formattedData)

    const width =
        dimensions.width > 800 ? dimensions.width / 2.2 : dimensions.width - 20

    useEffect(() => {
        if (scrollViewRef.current) {
            scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true })
        }
    }, [page])

    useEffect(() => {
        amplitude.track(`school_card_report.diagnostic_screen_${page}.see_more`)
    }, [page])

    return (
        <ScrollView
            scrollViewRef={scrollViewRef}
            showsVerticalScrollIndicator={false}
            showsHorizontalScrollIndicator={false}
            horizontal={false}
            style={{ flex: 1, width: "100%" }}
            contentContainerStyle={{
                flexGrow: 1,
                alignItems: "center",
            }}
        >
            <LinearGradient
                colors={pageData.colors}
                style={{
                    flex: 1,
                    paddingTop: 20,
                    width: "100%",
                    height: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <View
                    style={{
                        flexDirection: "row",
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        paddingHorizontal: 10,
                    }}
                >
                    <View style={{ width: 50, alignItems: "flex-start" }}>
                        <IconButton
                            size={32}
                            icon="times"
                            containerColor={theme.colors.transparent}
                            iconColor={theme.colors.primary}
                            onPress={() => {
                                amplitude.track(
                                    `times.school_card_report.diagnostic_screen_${page}.see_more.back`
                                )
                                navigation.goBack()
                            }}
                        />
                    </View>

                    <View style={{ flex: 1 }}>
                        <TextM
                            fontSize={32}
                            fontWeight="ExtraBold"
                            color={theme.colors.primary}
                            style={{
                                textAlign: "center",
                            }}
                            wrap
                        >
                            Avis sur la motivation de {studentName}
                        </TextM>
                    </View>
                </View>

                <View
                    style={{
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        paddingHorizontal: 20,
                        margin: 20,
                        width,
                    }}
                >
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            width,
                            marginTop: 10,
                            marginBottom: 20,
                        }}
                    >
                        <ChampionImageM
                            name={pageData?.champion}
                            variant={pageData?.championVariant[pageData?.score]}
                            width={80}
                        />

                        <View style={{ flex: 1, marginLeft: 10 }}>
                            <SpeechBubbleM
                                texts={[getPageComment(pageData)]}
                                position="left"
                                hideIcons={true}
                                noAnimation={true}
                                containerStyle={{
                                    flex: 1,
                                }}
                                textStyle={{
                                    fontSize: 16,
                                    fontFamily: "Montserrat-Regular",
                                    color: theme.colors.black,
                                }}
                            />
                        </View>
                    </View>

                    <GiftedChat
                        messages={messages}
                        user={{ _id: 1 }}
                        onSend={() => {}}
                        renderBubble={(props) => (
                            <View style={{ width: "100%" }}>
                                <TextM
                                    fontSize={12}
                                    fontWeight="bold"
                                    color={theme.colors.black}
                                    style={{
                                        marginLeft:
                                            props.position === "left" ? 10 : 0,
                                        marginRight:
                                            props.position === "right" ? 10 : 0,
                                        textAlign:
                                            props.position === "left"
                                                ? "left"
                                                : "right",
                                    }}
                                >
                                    {props.currentMessage.user.name !==
                                    "NonTrouvé"
                                        ? props.currentMessage.user.name
                                        : ""}
                                </TextM>
                                <Bubble
                                    {...props}
                                    containerStyle={{
                                        left: {
                                            width: "100%",
                                        },
                                        right: {
                                            width: "100%",
                                        },
                                    }}
                                    wrapperStyle={{
                                        left: {
                                            width: "70%",
                                            backgroundColor: "white",
                                            borderRadius: 16,
                                            padding: 12,
                                            marginBottom: 10,
                                        },
                                        right: {
                                            width: "70%",
                                            backgroundColor: "white",
                                            borderRadius: 16,
                                            padding: 12,
                                            marginBottom: 10,
                                        },
                                    }}
                                    textStyle={{
                                        left: {
                                            color: "#333",
                                            fontSize: 16,
                                            flexWrap: "wrap",
                                            textAlign: "center",
                                        },
                                        right: {
                                            color: "#333",
                                            fontSize: 16,
                                            textAlign: "center",
                                            flexWrap: "wrap",
                                        },
                                    }}
                                />
                            </View>
                        )}
                        renderInputToolbar={() => null}
                        showUserAvatar={false}
                        renderAvatar={null}
                    />
                </View>

                <View
                    style={{
                        width: "100%",
                        paddingHorizontal: 20,
                        gap: 20,
                        marginTop: "auto",
                        marginBottom: 20,
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <FilledButtonM
                        onPress={() => navigation.goBack()}
                        label="Retour"
                        trackingId={`school_card_report.diagnostic_screen_${page}.see_more.back`}
                    />
                </View>
            </LinearGradient>
        </ScrollView>
    )
}

const mapStateToProps = (state) => ({
    analysisData: state.data.schoolCardReport?.analysisData || {},
})

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MotivationSeeMoreScreen)
